import { useDateTimeFormat } from '~/hooks';

export default function ExpenseReportDetails({ expenseReport }) {
  const dateTimeFormat = useDateTimeFormat();

  return [
    expenseReport.number ? `#${expenseReport.number}` : null,
    expenseReport.title,
    expenseReport.member?.name,
    expenseReport.date ? dateTimeFormat.format(expenseReport.date) : null,
  ]
    .filter(Boolean)
    .join(' - ');
}
